export const PANTANAL_SCHEMA = {
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://everest.ind.br/pt#organization",
   "name": "Everest Refrigeração Indústria e Comércio",
   "url": "https://everest.ind.br/pt"
  },
  {
   "@type": "WebSite",
   "@id": "https://everest.ind.br/pt#website",
   "url": "https://everest.ind.br/pt",
   "name": "Everest | Purificadores e Máquinas de Gelo",
   "publisher": {
    "@id": "https://everest.ind.br/pt#organization"
   },
   "inLanguage": "pt-BR",
   "potentialAction": {
    "@type": "SearchAction",
    "target": "https://everest.ind.br/pt?s={search_term_string}",
    "query-input": "required name=search_term_string"
   }
  },
  {
   "@type": "WebPage",
   "@id": "https://everest.ind.br/pt/sos-pantanal#webpage",
   "url": "https://everest.ind.br/pt/sos-pantanal",
   "name": "SOS Pantanal | Everest",
   "description": "A Everest apoia o projeto SOS Pantanal, voltado para a preservação dos recursos hídricos e do bioma Pantanal.",
   "inLanguage": "pt-BR",
   "isPartOf": {
    "@id": "https://everest.ind.br/pt#website"
   },
   "about": {
    "@id": "https://everest.ind.br/pt#organization"
   },
   "publisher": {
    "@id": "https://everest.ind.br/pt#organization"
   },
   "breadcrumb": {
    "@id": "https://everest.ind.br/pt/sos-pantanal#breadcrumb"
   },
   "mainEntity": {
    "@type": "Article",
    "headline": "SOS Pantanal | Everest",
    "description": "Iniciativa da Everest em apoio ao projeto SOS Pantanal para preservação ambiental.",
    "author": {
     "@id": "https://everest.ind.br/pt#organization"
    }
   }
  },
  {
   "@type": "BreadcrumbList",
   "@id": "https://everest.ind.br/pt/sos-pantanal#breadcrumb",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://everest.ind.br/pt"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "SOS Pantanal",
     "item": "https://everest.ind.br/pt/sos-pantanal"
    }
   ]
  }
 ]
}
